import { ContactGrid } from "components/Contacts/ContactGrid";
import { ExportDataButton } from "components/ExportDataButton";
import { useTenant } from "hooks/useTenant";
import { useMemo } from "react";

export function OnboardingContacts({ tenantId }: { tenantId: string }) {
  const { tenant } = useTenant();
  // an isStaff check here may be a little overkill since we are nested under
  // a "staff" route... but the component doesn't know that, and it seems like
  // a decent candidate for getting refactored into a general-purpose contact
  // table
  const importExportButtons = useMemo(() => {
    const buttons = [
      <ExportDataButton
        key="export"
        disabled={!tenantId}
        tenantId={tenantId}
        exportType="contact"
        fileName={`${tenant?.name ?? tenantId}-contact-catalog`}
      />,
    ];

    return buttons;
    // oxlint-disable-next-line exhaustive-deps -- Grandfathered in error. Future hooks should be exhaustive
  }, [tenantId]);

  return <ContactGrid tenantId={tenantId} commandButtons={importExportButtons} />;
}
